import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";

export default function OrgHeadFiles(props) {
  const { order, orderBy, onSort } = props;
  const { isSmallMobileScreen } = useResponsiveFlags();
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 0,
                  zIndex: 12,
                }
              : {}
          }
        >
        </TableCell>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 45,
                  zIndex: 11,
                }
              : {}
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Org ID
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "id"}
              onClick={() => onSort("id")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Name
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "name"}
              onClick={() => onSort("name")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Address
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "address"}
              onClick={() => onSort("address")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "134px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              City
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "city"}
              onClick={() => onSort("city")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              State
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "state"}
              onClick={() => onSort("state")}
            />
          </div>
        </TableCell>

        <TableCell style={{ minWidth: "97px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Zip
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "zip"}
              onClick={() => onSort("zip")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "97px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Country
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "country"}
              onClick={() => onSort("country")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "97px" }}>
          <span className="storage-limit" style={{ marginRight: "8px" }}>
            Users
          </span>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Reg Date
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "reg_date"}
              onClick={() => onSort("reg_date")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Provisional
            </span>
        </TableCell>
        <TableCell style={{ minWidth: "97px" }}>
          <span className="storage-limit" style={{ marginRight: "8px" }}>
            Org Code
          </span>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
